import { CSSProperties, HTMLAttributes, type PropsWithChildren } from 'react';
import { tv } from '../_lib/utils';

export const styles = tv({
	slots: {
		base: '',
	},
	variants: {
		hasParagraphs: {
			true: {
				base: '[&>*+*]:mt-[0.75em] [&>:empty]:hidden break-words',
			},
		},
		type: {
			'heading-4xl': {
				base: 'font-poppins text-heading-4xl',
			},
			'heading-3xl': {
				base: 'font-poppins text-heading-3xl',
			},
			'heading-2xl': {
				base: 'font-poppins text-heading-2xl',
			},
			'heading-xl': {
				base: 'font-poppins text-heading-xl',
			},
			'heading-lg': {
				base: 'font-poppins text-heading-lg',
			},
			'heading-md': {
				base: 'font-poppins text-heading-md',
			},
			'heading-sm': {
				base: 'font-poppins text-heading-sm',
			},
			'heading-xs': {
				base: 'font-poppins text-heading-xs',
			},
			'heading-2xs': {
				base: 'font-poppins text-heading-2xs',
			},
			'heading-2xs-semibold': {
				base: 'font-poppins text-heading-2xs font-semibold',
			},
			'heading-3xs': {
				base: 'font-poppins text-heading-3xs',
			},
			'heading-4xs': {
				base: 'font-poppins text-heading-4xs',
			},
			'heading-5xs': {
				base: 'font-poppins text-heading-5xs',
			},
			'heading-5xs-semibold': {
				base: 'font-poppins text-heading-5xs font-semibold',
			},
			'heading-6xs': {
				base: 'font-poppins text-heading-6xs',
			},
			'body-6xl': {
				base: 'font-poppins text-body-6xl',
			},
			'body-6xl-medium': {
				base: 'font-poppins text-body-6xl font-medium',
			},
			'body-5xl': {
				base: 'font-poppins text-body-5xl',
			},
			'body-5xl-medium': {
				base: 'font-poppins text-body-5xl font-medium',
			},
			'body-4xl': {
				base: 'font-poppins text-body-4xl',
			},
			'body-4xl-medium': {
				base: 'font-poppins text-body-4xl font-medium',
			},
			'body-3xl': {
				base: 'font-poppins text-body-3xl',
			},
			'body-3xl-medium': {
				base: 'font-poppins text-body-3xl font-medium',
			},
			'body-2xl': {
				base: 'font-poppins text-body-2xl',
			},
			'body-2xl-medium': {
				base: 'font-poppins text-body-2xl font-medium',
			},
			'body-xl': {
				base: 'font-poppins text-body-xl',
			},
			'body-xl-medium': {
				base: 'font-poppins text-body-xl font-medium',
			},
			'body-xl-semibold': {
				base: 'font-poppins text-body-xl font-semibold',
			},
			'body-lg': {
				base: 'font-poppins text-body-lg',
			},
			'body-lg-medium': {
				base: 'font-poppins text-body-lg font-medium',
			},
			'body-lg-semibold': {
				base: 'font-poppins text-body-lg font-semibold',
			},
			'body-md': {
				base: 'font-poppins text-body-md',
			},
			'body-md-medium': {
				base: 'font-poppins text-body-md font-medium',
			},
			'body-md-semibold': {
				base: 'font-poppins text-body-md font-semibold',
			},
			'body-sm': {
				base: 'font-poppins text-body-sm',
			},
			'body-sm-medium': {
				base: 'font-poppins text-body-sm font-medium',
			},
			'body-sm-semibold': {
				base: 'font-poppins text-body-sm font-semibold',
			},
			'body-xs': {
				base: 'font-poppins text-body-xs',
			},
			'body-xs-medium': {
				base: 'font-poppins text-body-xs font-medium',
			},
			'body-xs-semibold': {
				base: 'font-poppins text-body-xs font-semibold',
			},
			'body-2xs': {
				base: 'font-poppins text-body-2xs',
			},
			'body-2xs-medium': {
				base: 'font-poppins text-body-2xs font-medium',
			},
			'label-2xl': {
				base: 'font-poppins text-label-2xl uppercase',
			},
			'label-xl': {
				base: 'font-poppins text-label-xl uppercase',
			},
			'label-lg': {
				base: 'font-poppins text-label-lg uppercase',
			},
			'label-md': {
				base: 'font-poppins text-label-md uppercase',
			},
			'label-sm': {
				base: 'font-poppins text-label-sm uppercase',
			},
			'label-xs': {
				base: 'font-poppins text-label-xs uppercase',
			},
			'label-2xs': {
				base: 'font-poppins text-label-2xs uppercase',
			},
			'button-xl': {
				base: 'font-poppins text-button-xl',
			},
			'button-lg': {
				base: 'font-poppins text-button-lg',
			},
			'button-md': {
				base: 'font-poppins text-button-md',
			},
			'button-sm': {
				base: 'font-poppins text-button-sm',
			},
			'button-xs': {
				base: 'font-poppins text-button-xs',
			},
			'quote-lg': {
				base: 'font-poppins text-quote-lg',
			},
			'quote-md': {
				base: 'font-poppins text-quote-md',
			},
			'quote-sm': {
				base: 'font-poppins text-quote-sm',
			},
			'quote-xs': {
				base: 'font-poppins text-quote-xs',
			},
			'stat-xl': {
				base: 'font-poppins text-stat-xl',
			},
			'stat-lg': {
				base: 'font-poppins text-stat-lg',
			},
			'stat-md': {
				base: 'font-poppins text-stat-md',
			},
			'stat-sm': {
				base: 'font-poppins text-stat-sm',
			},
			'chip-lg': {
				base: 'font-poppins text-chip-lg',
			},
			'chip-md': {
				base: 'font-poppins text-chip-md',
			},
			'chip-sm': {
				base: 'font-poppins text-chip-sm',
			},
			'editorial-lg': {
				base: 'font-poppins text-editorial-lg',
			},
			'editorial-lg-semibold': {
				base: 'font-poppins text-editorial-lg font-semibold',
			},
			'editorial-md': {
				base: 'font-poppins text-editorial-md',
			},
			'editorial-md-semibold': {
				base: 'font-poppins text-editorial-md font-semibold',
			},
		},
	},
});

export type TextProps = {
	as?: string;
	className?: string;
	hasParagraphs?: boolean;
	styleType: (typeof styleTypes)[number];
} & HTMLAttributes<HTMLElement>;

export function Text({ as: El = 'div', styleType, className, hasParagraphs = false, ...props }: PropsWithChildren<TextProps>) {
	const { base } = styles({ hasParagraphs, type: styleType });

	return (
		// @ts-expect-error
		<El {...props} className={`${base()} ${className || ''}`}>
			{props.children}
		</El>
	);
}

export const styleTypes = [
	'heading-4xl',
	'heading-3xl',
	'heading-2xl',
	'heading-xl',
	'heading-lg',
	'heading-md',
	'heading-sm',
	'heading-xs',
	'heading-2xs',
	'heading-2xs-semibold',
	'heading-3xs',
	'heading-4xs',
	'heading-5xs',
	'heading-5xs-semibold',
	'heading-6xs',
	'body-6xl',
	'body-6xl-medium',
	'body-5xl',
	'body-5xl-medium',
	'body-4xl',
	'body-4xl-medium',
	'body-3xl',
	'body-3xl-medium',
	'body-2xl',
	'body-2xl-medium',
	'body-xl',
	'body-xl-medium',
	'body-xl-semibold',
	'body-lg',
	'body-lg-medium',
	'body-lg-semibold',
	'body-md',
	'body-md-medium',
	'body-md-semibold',
	'body-sm',
	'body-sm-medium',
	'body-sm-semibold',
	'body-xs',
	'body-xs-medium',
	'body-xs-semibold',
	'body-2xs',
	'body-2xs-medium',
	'label-2xl',
	'label-xl',
	'label-lg',
	'label-md',
	'label-sm',
	'label-xs',
	'label-2xs',
	'button-xl',
	'button-lg',
	'button-md',
	'button-sm',
	'button-xs',
	'quote-lg',
	'quote-md',
	'quote-sm',
	'quote-xs',
	'stat-xl',
	'stat-lg',
	'stat-md',
	'stat-sm',
	'chip-lg',
	'chip-md',
	'chip-sm',
	'editorial-lg',
	'editorial-lg-semibold',
	'editorial-md',
	'editorial-md-semibold',
] as const;
